import React, { useState, lazy, Suspense } from "react";
import { Text } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getStateTrailById } from "../../utils/fetch";
import { parseTrailData } from "../../utils/trails";
import { useRoute } from "@react-navigation/native";
import { logAnalyticsEvent } from "../../utils/firebase";
const StateDetailsCommon = lazy(() => import("./StateDetailsCommon"));
const MapViewDetailWeb = lazy(() => import("../DetailsView/MapViewDetail.web"));

const StateDetailsView = () => {
  logAnalyticsEvent("screen_view", { name: "Trails-StateDetails" });

  const route = useRoute();

  const [trailData, setTrailData] = useState([]);
  const [trailLat, setTrailLat] = useState([]);
  const [trailLng, setTrailLng] = useState([]);
  const [trailPolyline, setTrailPolyline] = useState([]);

  /**
   * Fetches trail data based on the state trail ID from the route parameters,
   * parses the trail data, and updates the state with the trail attributes,
   * latitude, longitude, and polyline.
   *
   * @async
   * @function getTrailData
   * @returns {Promise<void>} A promise that resolves when the trail data is fetched and state is updated.
   */
  const getTrailData = async () => {
    const detail = await getStateTrailById(route?.params?.id);
    const getTrailData = await parseTrailData(detail);
    setTrailData(getTrailData[0].attributes);
    setTrailLat(parseFloat(getTrailData[0].lat));
    setTrailLng(parseFloat(getTrailData[0].lng));
    setTrailPolyline(getTrailData[0].polyline);
  };

  React.useEffect(() => {
    getTrailData();
  }, []);

  return (
    <Suspense fallback={<Text>Loading...</Text>}>
      <StateDetailsCommon
        detail={trailData}
        lat={trailLat}
        lng={trailLng}
        polyline={trailPolyline}
        FontAwesomeIcon={FontAwesomeIcon}
        MapComponent={MapViewDetailWeb}
      />
    </Suspense>
  );
};

export default StateDetailsView;
